import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { EmailSubscription, EmailTemplate, Query } from '@deckplan.io/common';
import { Mockable } from '../../mocks/mockable.decorator';
import { UrlUtils } from '../utils/url-utils';

@Injectable({
    providedIn: 'root'
})
@Mockable
export class MailerService {

    private readonly backendUrl = UrlUtils.constructBackendUrl('mailer');

    constructor(private readonly http: HttpClient) {}

    public getAll(): Observable<EmailTemplate[]> {
        return this.http.get<EmailTemplate[]>(`${this.backendUrl}/templates`);
    }

    public create(template: EmailTemplate): Observable<EmailTemplate> {
        return this.http.post<EmailTemplate>(`${this.backendUrl}/templates`, template);
    }

    public update(id: number, updates: any): Observable<EmailTemplate> {
        return this.http.put<EmailTemplate>(`${this.backendUrl}/templates/${id}`, updates);
    }

    public delete(id: number): Observable<EmailTemplate> {
        return this.http.delete<EmailTemplate>(`${this.backendUrl}/templates/${id}`);
    }

    public sendMassMail(userQuery: Query, template: string) {
        return this.http.post<any>(`${this.backendUrl}/send`, {userQuery, template});
    }

    public sendContactSupportEmail(senderFirstName: string, senderLastName: string, senderEmail: string, senderMessage: string) {
        return this.http.post<any>(`${this.backendUrl}/sendContactSupport`, {senderFirstName, senderLastName, senderEmail, senderMessage});
    }

}
